import { createFileRoute } from '@tanstack/react-router';
import { PhoneCall } from 'lucide-react';
import { EmptyState } from '@/components/atoms/EmptyState';
import { LiveCallsPanel } from '@/components/calls/live/LiveCallsPanel';
import { useAuthStore } from '@/stores/auth.store';
import { canMonitorLiveCalls } from '@/lib/calls/liveCalls';

// Live call monitoring: every call on the account right now, with live
// transcripts. Gated in the component rather than in beforeLoad: the auth store
// can still be hydrating on a hard refresh, and bouncing a manager off the page
// because their permissions had not loaded yet is worse than showing the
// no-access state for a frame. The operations API enforces the same rule.
export const Route = createFileRoute('/_dashboard/dashboard/live-calls')({
  component: LiveCallsPage,
});

function LiveCallsPage() {
  const permissions = useAuthStore((s) => s.permissions);
  const permissionScopes = useAuthStore((s) => s.permissionScopes);

  if (!canMonitorLiveCalls(permissions, permissionScopes)) {
    return (
      <EmptyState
        icon={PhoneCall}
        title="You don't have access to live call monitoring"
        description="It needs permission to view calls across the whole account."
      />
    );
  }

  return (
    <div className="flex h-[calc(100vh-var(--header-height,64px))] -m-6 flex-col overflow-hidden">
      <LiveCallsPanel />
    </div>
  );
}
